export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f9c5ed9563e27df98e3055b58a105e7696069c0e3&name=fetchTypeahead!'